import { restoreGeneratedCopyReview } from './generated-copy-store';
import { openGenerateSession } from './generate-with-ai-store';
import { generateSessionForPending } from './usage-sidebar-logic';
import { signalStepsReopen, type PendingUsageSidebar } from './usage-sidebar-store';

/**
 * Codex fixes 2026-09-17, F2–F5 — what the ORIGIN does with a
 * `'resume-review'` decision. React-free (zustand actions only) so
 * `SequencesStep`, `SequenceCopyPane` and the bun suite share one body.
 *
 * Runs only once the origin surface is the one on screen — that is the
 * caller's contract, enforced by `use-usage-sidebar-decision.ts`'s
 * origin-key match plus `SequencesStep`'s flow-settled gate — so the three
 * calls below land where the rep can see them:
 *  1. re-hydrate the staged review if the flow-store clear took it
 *     (`restoreGeneratedCopyReview`, no-op when the live entry survived);
 *  2. for a rung origin, reopen the Steps accordion the review cards live
 *     in (`signalStepsReopen` — the same signal a landed AI-apply write
 *     uses; a rail click away and back remounts the shell closed);
 *  3. open the Generate session for the origin's (scope, sequence, surface)
 *     — `openGenerateSession` closes the sidebar itself (OQ4), and
 *     `GenerateWithAIDrawer`'s resume effect lands on `'review'` because the
 *     entry is `'ready'`.
 *
 * `false` when the pending is not an AI-Apply sequence save (the sidebar
 * never offers the control for those, so this is a caller bug, surfaced by
 * the hook closing the sidebar with nothing written).
 */
export function resumeReviewFromPending(pending: PendingUsageSidebar): boolean {
  const session = generateSessionForPending(pending);
  if (session === null) return false;
  if (pending.stagedReview !== undefined) {
    restoreGeneratedCopyReview(session.scope, session.sequenceId, pending.stagedReview);
  }
  if (pending.origin.kind !== 'library') signalStepsReopen(pending.origin.rungDraftKey);
  openGenerateSession(session);
  return true;
}
